import React, { useId } from "react";
import PropTypes from "prop-types";
import { Check, CircleAlert } from "lucide-react";

const FormStepBar = ({ currentStep, onStepSelect, steps }) => {
  const labelId = useId();
  const currentIndex = steps.findIndex((step) => step.id === currentStep);

  return (
    <nav aria-labelledby={labelId} className="wsm-form-steps">
      <span className="wsm-form-steps__label" id={labelId}>Pack creation progress</span>
      <ol>
        {steps.map((step, index) => {
          const state = step.error ? "error" : index < currentIndex ? "complete" : index === currentIndex ? "current" : "upcoming";
          const StepIcon = step.icon;
          const content = (
            <>
              <span className="wsm-form-steps__icon">
                {state === "complete" ? <Check aria-hidden="true" /> : state === "error" ? <CircleAlert aria-hidden="true" /> : StepIcon && <StepIcon aria-hidden="true" />}
              </span>
              <span className="wsm-form-steps__text">
                <strong>{step.label}</strong>
                {step.description && <small>{step.description}</small>}
              </span>
            </>
          );

          return (
            <li className={`wsm-form-steps__step wsm-form-steps__step--${state}`} key={step.id}>
              {step.href && state !== "current" ? <a href={step.href}>{content}</a> : onStepSelect && state === "complete" ? <button onClick={() => onStepSelect(step.id)} type="button">{content}</button> : <div aria-current={state === "current" ? "step" : undefined}>{content}</div>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

FormStepBar.propTypes = {
  currentStep: PropTypes.string.isRequired,
  onStepSelect: PropTypes.func,
  steps: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
    error: PropTypes.bool,
    href: PropTypes.string,
    icon: PropTypes.elementType.isRequired,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
};

export default FormStepBar;